import type { UserJob } from '../types/rest-api';

/**
 * Resolves the Berufsbezeichnung to pre-fill when an existing admin is suggested
 * as a job Ansprechperson.
 *
 * Precedence:
 * 1. The primary Berufsbezeichnung from the admin's Fachkräfteprofil (the first
 *    of `jobs`), preferring the canonical `job_title` over a free-text
 *    `custom_job_title`. This always wins when present.
 * 2. Otherwise the school-level öffentliche Berufsbezeichnung (the school
 *    contact's `title`), as a fallback when the Fachkräfteprofil has none.
 *
 * The placeholder `'-'` the backend stores for "no öffentliche Berufsbezeichnung"
 * is treated as empty.
 */
export function resolveAdminJobFunction(
  schoolJobFunction: string | null | undefined,
  profileJobs:
    | Pick<UserJob, 'job_title' | 'custom_job_title'>[]
    | null
    | undefined
): string {
  const primary = (profileJobs ?? []).find(
    job => (job.job_title ?? job.custom_job_title ?? '').trim() !== ''
  );
  const profileJobFunction = (
    primary?.job_title ??
    primary?.custom_job_title ??
    ''
  ).trim();
  if (profileJobFunction) return profileJobFunction;

  const existing = (schoolJobFunction ?? '').trim();
  return existing === '-' ? '' : existing;
}
